import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import PostAddIcon from '@mui/icons-material/PostAdd';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { useNavigate } from "react-router-dom";

const Item = styled(Button)(({ theme }) => ({
    backgroundColor: "#F7F2FA",
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    height: 150,
    display: "inline",
    textTransform: "none",
    width: "-webkit-fill-available",
    borderRadius: 20,
    '&:hover': {
      backgroundColor: "#d2cdd2",
    },
  }));

export default function Fornecedor(){

    const navigate = useNavigate();
  
    const NavigateTo = (path: string) => {
      navigate(path);
    }
    return(
        <Box sx={{ width: "100%" }}>
        <p style={{ color: "#C9C4D0", fontStyle: "bold" }}>Fornecedor</p>
        <h1 style={{ color: "#47454E" }}>Gestão de Fornecedores</h1>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          <Grid item xs={1.5} sm={1.5} md={1.5} key="user">
            <Item onClick={() => NavigateTo("../cadastrarfornecedor")}>
              <PostAddIcon
                fontSize="large"
                sx={{ color: "#47454E", fontSize: "5em" }}
              ></PostAddIcon>
              <p>Cadastro de Fornecedor</p>
            </Item>
          </Grid>
          <Grid item xs={1.5} sm={1.5} md={1.5} key="i">
            <Item onClick= {() => NavigateTo("../consultarfornecedor")}>
              <ManageSearchIcon
                fontSize="large"
                sx={{ color: "#47454E", fontSize: "5em" }}
              ></ManageSearchIcon>
              <p>Consulta de Fornecedor</p>
            </Item>
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={2}></Grid>
          <Grid item xs={2}></Grid>
          <Grid item xs={2}></Grid>
          <Grid item xs={2}></Grid>
          <Grid item xs={12}>
            <Divider></Divider>
          </Grid>
        </Grid>
      </Box>
    )
}